import { Component } from '@angular/core';

@Component({
  selector: 'quotely-home',
  templateUrl: './home.component.html',
})
export class HomeComponent {
}
